import { Download } from 'lucide-react'
import { PagePlaceholder } from '../components/ui/PagePlaceholder'

export function Export() {
  return (
    <PagePlaceholder
      title="Esporta"
      description="Scarica la dashboard completa in Excel (un foglio per sezione KPI) o PDF con tabella riepilogativa."
      icon={Download}
    />
  )
}
